module.exports = __webpack_public_path__ + "img/Weapon_97.3c3387d0.png";